import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "button"]

  toggle() {
    this.contentTarget.classList.toggle("hidden")

    if (this.contentTarget.classList.contains("hidden")) {
      this.buttonTarget.innerHTML = this.getShowMoreText()
    } else {
      this.buttonTarget.innerHTML = this.getShowLessText()
    }
  }

  getShowMoreText() {
    return `
      <svg class="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
      </svg>
      ${this.buttonTarget.dataset.showMore || 'Voir plus'}
    `
  }

  getShowLessText() {
    return `
      <svg class="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 15l7-7 7 7" />
      </svg>
      ${this.buttonTarget.dataset.showLess || 'Voir moins'}
    `
  }
}
